var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "px-0", staticStyle: { "max-width": "540px" } },
    [
      _c("v-text-field", {
        staticClass: "mb-6",
        staticStyle: {
          "border-radius": "36px !important",
          position: "sticky",
          top: "0px",
          "z-index": "100",
        },
        attrs: {
          rounded: "",
          solo: "",
          label: "Search Instruments",
          placeholder: "Search Instruments",
          "hide-details": "",
        },
        model: {
          value: _vm.search,
          callback: function ($$v) {
            _vm.search = $$v
          },
          expression: "search",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "soli-round pa-1" },
        [
          _vm.loading
            ? _c("v-skeleton-loader", {
                staticClass: "mx-auto my-3",
                attrs: {
                  type: "list-item-avatar, list-item-avatar, list-item-avatar",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("v-data-iterator", {
            staticStyle: {
              "max-height": "36vh",
              "overflow-y": "auto",
              "overflow-x": "hidden",
            },
            attrs: {
              items: _vm.getInstruments,
              "disable-pagination": "",
              search: _vm.search,
              "hide-default-footer": "",
              "no-results-text": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function (data) {
                  return [
                    !_vm.loading
                      ? _c(
                          "v-list",
                          { staticClass: "py-0 px-2 mb-2 full-round" },
                          [
                            _c("SoliAvatarBtn", {
                              attrs: {
                                avatar: data.item.icon
                                  ? null
                                  : data.item.photo_url
                                  ? `${data.item.photo_url}/m/80x80`
                                  : "/musicologie-m-white.png",
                                subtitleBottom: data.item.market,
                                blueShadow: "",
                                outlined: false,
                                title: data.item.name,
                                icon: data.item.icon ?? null,
                                ripple: true,
                                append: _vm.getDistance
                                  ? null
                                  : "chevron_right",
                                id: data.item.id,
                              },
                              on: {
                                click: function ($event) {
                                  ;[
                                    _vm.$emit(
                                      "input",
                                      _vm.returnObject
                                        ? data.item
                                        : data.item.id
                                    ),
                                  ]
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }